import { Component, Input, OnInit } from '@angular/core';
import { User } from './../../common/models/user';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from './../services/authentication.service';
import { UserService } from './../services/user.service';


@Component({
  selector: 'app-loginstatus',
  template: `
  <a class="nav-item active" *ngIf="(isLoggedIn | async)" >
    <a class="nav-link" routerLink="/home" routerLinkActive="active">Hi {{user.firstName}}</a>
    <a class="nav-link" (click)="logout()" routerLinkActive="active"> | Logout</a>
  
  </a>
  <a class="nav-item active" *ngIf="!(isLoggedIn | async)">
    <a class="nav-link" routerLink="/login" routerLinkActive="active">Login</a>
  </a>  
  `,
  styles: ['a { display: inline-block; }' ,'.nav-item { cursor: pointer; cursor: hand; }','a{text-decoration: none}']
})
export class LoginstatusComponent implements OnInit {

  @Input() user: User;
  isLoggedIn : Observable<boolean>;

  constructor(private router: Router, private authenticationService: AuthenticationService) {
    this.isLoggedIn = authenticationService.isLoggedIn();
  }
  errorMessage = "";

  ngOnInit() {
     this.authenticationService.isLoggedIn().subscribe(loggedIn => { 
      this.user = JSON.parse(localStorage.getItem("currentUser"));
     });
      
  }

  logout() {
    var isLoggedout = false;
    isLoggedout = this.authenticationService.logout().subscribe(result => {
      if (result.status==200) {
        this.authenticationService.removeCurrentUser();
        this.router.navigate(['home']); //destination after logged out
        //window.location.reload();
      }else{
        this.errorMessage="there is a problem! try again!. :) "
      }
    });
  }

  goToEmbla(){
  // var params = {
  //     access_token: 'An access_token',
  //     other_header: 'other_header'
  // };
  // //Add authentication headers in URL
  // var url = ['http://localhost:55608/News/List', $.param(params)].join('?');
  
  // //Open window
  // window.open(url);
  //   window.location.href = '...';
  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/authentication/loginstatus/loginstatus.component.ts